import React from 'react';

/**
 * «Admite médico visitante» (administración, 7/10/2026), en Nueva agenda y en
 * Configurar agenda. El médico visitante del día (MedicoVisitanteDia) no va en
 * todas las agendas: solo en las que la clínica marca aquí. Qué agendas son lo
 * decide la clínica, no el código. Sin marcar, la agenda no lo ofrece; si ya
 * tenía alguno apuntado, se sigue viendo pero no se cambia.
 *
 * Props: { prefijo, checked, onChange }
 */
export default function AdmiteVisitanteCasilla({ prefijo, checked, onChange }) {
  const id = `${prefijo}-admite-visitante`;
  return (
    <label className="flex items-start gap-2 text-sm" htmlFor={id}>
      <input
        id={id}
        type="checkbox"
        className="mt-0.5"
        checked={!!checked}
        onChange={(e) => onChange(e.target.checked)}
        data-testid={id}
      />
      <span>
        <span className="font-medium text-[#13231E]">Admite médico visitante</span>
        <span className="block text-xs text-muted-foreground">
          En la vista de día de esta agenda se puede apuntar quién viene ese día de visita, con su
          especialidad (lo normal, uno; como mucho, dos). Sin marcar, la agenda no lo ofrece.
        </span>
      </span>
    </label>
  );
}
